var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "5.75 1.75 20.5 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.97 1.75H7.03c-.71 0-1.28.57-1.28 1.28v25.94c0 .71.57 1.28 1.28 1.28h17.94c.71 0 1.28-.57 1.28-1.28V3.03c0-.71-.57-1.28-1.28-1.28zm-3.13 15.01-5.66 5.66c-.05.05-.12.07-.18.07s-.13-.02-.18-.07l-5.66-5.66c-.8-.8-1.24-1.87-1.24-3 0-1.14.44-2.21 1.24-3.01.81-.8 1.88-1.24 3.01-1.24 1.05 0 2.05.38 2.83 1.07.78-.69 1.78-1.07 2.83-1.07 1.13 0 2.2.44 3.01 1.24.8.8 1.24 1.87 1.24 3.01 0 1.13-.44 2.2-1.24 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.6890703b93db380402b05f9d9fad0f64.svg";
export { ForwardRef as ReactComponent };